module.exports = __webpack_public_path__ + "img/icon_map_hssh.fe6a583d.png";